<template>
	<div class="o-container o-container--thin">
		<global-message v-bind="message" />
		<login-form
			v-if="visibleForm === 'full'"
			:submit="login"
			:email="email"
			:issue="issue"
		/>

		<simplified-login-form
			v-if="visibleForm === 'simplified'"
			:submit="login"
			:email="email"
		/>
	</div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import LoginForm from '../forms/LoginForm.vue';
	import SimplifiedLoginForm from '../forms/SimplifiedLoginForm.vue';
	import isEmail from "../../helpers/isEmail";
  import '../../store/modules/session/session';

	export default {
    components: {
      GlobalMessage,
      LoginForm,
      SimplifiedLoginForm
    },
    props: {
      message: Object,
      form: String,
      issue: String
    },
    data() {
      return {
        email: this.$session.has('register_email') ? this.$session.get('register_email') : ''
      }
    },
    computed: {
      ...mapState('onboarding', {
        onboardingcomplete: state => state.form.onboardingcomplete
      }),
      checked() {
        const checkedProps = {};

        if (isEmail(this.email)) {
          let emailProp = this.email;
          checkedProps.email = emailProp.toLowerCase();
        }

        return checkedProps;
      },
      visibleForm() {
        if (this.form === 'simplified' && this.checked.email) {
          return 'simplified';
        }

        return 'full';
			}
		},
		methods: {
      ...mapGetters('onboarding', ["subscribedToFanOffer"]),
      login(credentials) {
        console.info("START_user.Login");
        console.time("TIME_user.Login");

        return this.$store.dispatch('user/LOGIN', credentials).then(async () => {
          console.timeEnd("TIME_user.Login");

          console.info("START_calling_user.OPTIN");
          console.time("TIME_calling_user.OPTIN");

          if (this.subscribedToFanOffer()) {
            // await this.$store.dispatch('onboarding/OPTIN', {optin: this.$store.state.onboarding.optInFanOffer});
          }

          if (this.onboardingcomplete === 'Skipped' || this.onboardingcomplete === 'Not Completed') {
            // redirect to the Onboarding page
            await this.$router.push({name: 'onBoarding'});
          } else {
            // redirect to the My Account page
            await this.$router.push({name: 'myAccount'});
          }
        });
      }
    }
  }
</script>
